import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const badgeStyles = {
  neutral: {
    border: "border border-[#E4E4E7]",
    bg: "bg-[#F0F0F0]",
    text: "text-[#1D1B22]",
  },
  primary: {
    border: "border border-[#B5C8D6]",
    bg: "bg-[#E0E6EB]",
    text: "text-[#1E4A6B]",
  },
  red: {
    border: "border border-[#F6AEB3]",
    bg: "bg-[#FDEBED]",
    text: "text-[#D6001D]",
  },
  orange: {
    border: "border border-[#FFD78A]",
    bg: "bg-[#FEF7EB]",
    text: "text-[#F68E1A]",
  },
  green: {
    border: "border border-[#8FD9A2]",
    bg: "bg-[#E0F4E3]",
    text: "text-[#1FA14A]",
  },
  blue: {
    border: "border border-[#BFDBFE]",
    bg: "bg-[#EFF6FF]",
    text: "text-[#3B82F6]",
  },
};

function Badges({ label = "", variant = "" }) {
  const [t] = useTranslation();

  const styles = badgeStyles[variant] || badgeStyles.green;

  return (
    <div className={`flex items-start`}>
      <div
        className={`flex px-2 py-1 justify-center items-center gap-[2px] rounded-[6px] ${styles.border} ${styles.bg}`}
        style={{ borderRadius: "6px" }}
      >
        <span
          className={`text-center font-[600] text-[14px] leading-[20px] ${styles.text}`}
        >
          {t(label)}
        </span>
      </div>
    </div>
  );
}

Badges.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf([
    "neutral",
    "primary",
    "red",
    "orange",
    "green",
    "blue",
  ]),
};

export default Badges;
